export const authorsImageAndTextHandler = () => {
    const authorsName = document.querySelectorAll(
        ".author-top-section .author-group .author-name",
    );
    const otherAuthorsText = document.querySelector(
        ".author-top-section .author-group .author-others",
    );
    const authorsImageContainer = document.querySelector(
        ".author-top-section__image",
    );
    const authorsImages = authorsImageContainer.querySelectorAll("img");

    if (authorsName.length > 1) {
        // Remove authors image
        for (const authorsImage of authorsImages) {
            authorsImage.remove();
        }

        // Diplay image for multiple authors
        authorsImageContainer.classList.add("multiple-authors");

        if (authorsName.length > 4) {
            // Remove other authors name
            let count = 0;
            for (const authorName of authorsName) {
                if (count > 3 && count <= authorsName.length) {
                    authorName.remove();
                }

                count++;
            }

            // Display 'and others' text
            otherAuthorsText.classList.add("show");
        }
    } else {
        if (
            authorsImages.length > 0 &&
            authorsImages[0].classList.contains("loader")
        ) {
            // Display authors image
            authorsImages[0].classList.remove("loader");
        }
    }
};

export const authorsAndPublishedDateHandler = (isRecombee = false) => {
    const authorDateContainers = document.querySelectorAll(
        '[data-testid="text--author-and-published-date"]',
    );
    if (!authorDateContainers.length) return;

    // Typical height (px) of a single line of author/date text
    const singleLineHeightPx = 17;

    authorDateContainers.forEach((container) => {
        const containerParent = container.parentElement;
        const separatorElement = container.querySelector(
            '[data-testid="divider--circular_grey"]',
        );
        const headlineElement = containerParent?.querySelector(
            '[data-testid="text--article-headline"]',
        );

        // Get container height without the padding
        const rect = container.getBoundingClientRect();
        const style = getComputedStyle(container);
        const authorDateContainerHeight = rect.height - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);

        // Adjust layout if the container is taller than a single line/ wrapped.
        if (authorDateContainerHeight > singleLineHeightPx) {
            headlineElement?.classList.add("!line-clamp-2");
            separatorElement?.classList.add("hidden");
            container.classList.add("!flex-col", "!items-start", "gap-y-[2px]");

            if (isRecombee)
                container.parentElement.classList.add(
                    "adjusted-recombee-content",
                );
        }
    });
};
